module.exports = __webpack_public_path__ + "nsnapshot_icon.svg";